import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../motion/Reveal";
import { JOURNEY } from "../../data/content";

const Stage = ({ stage, index }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "start 0.4"] });
  const opacity = useTransform(scrollYProgress, [0, 1], [0.3, 1]);
  const x = useTransform(scrollYProgress, [0, 1], [30, 0]);

  return (
    <motion.div
      ref={ref}
      style={{ opacity, x }}
      data-testid={`journey-stage-${index}`}
      className="relative pl-10 md:pl-16 pb-16 last:pb-0 group"
    >
      {/* node */}
      <span className="absolute left-0 top-1.5 flex h-4 w-4 -translate-x-1/2 items-center justify-center">
        <span className="absolute h-4 w-4 rounded-full bg-gold/20" />
        <span className="h-2 w-2 rounded-full bg-gold group-hover:scale-150 transition-transform duration-300" />
      </span>
      <div className="flex items-baseline gap-4">
        <span className="font-mono text-xs text-gold">{stage.no}</span>
        <h3 className="font-serif text-3xl md:text-4xl text-bone tracking-tight">{stage.title}</h3>
      </div>
      <p className="mt-4 max-w-xl text-ash leading-relaxed">{stage.text}</p>
    </motion.div>
  );
};

export const Journey = () => {
  const lineRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: lineRef, offset: ["start 0.6", "end 0.6"] });
  const height = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section id="journey" className="relative py-24 md:py-36 bg-ink-soft/40 border-y border-white/10">
      <div className="container-editorial grid lg:grid-cols-12 gap-12">
        {/* sticky header */}
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <p className="overline mb-6">02 — The Journey</p>
              <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-bone">
                A Journey of <span className="italic text-gold">Change</span>
              </h2>
              <p className="mt-6 text-ash leading-relaxed max-w-sm">
                Five stages that shaped a more intentional relationship with markets — and with life.
              </p>
            </Reveal>
          </div>
        </div>

        {/* timeline */}
        <div className="lg:col-span-7 lg:col-start-6">
          <div ref={lineRef} className="relative">
            {/* track */}
            <div className="absolute left-0 top-1.5 bottom-1.5 w-px bg-white/10" />
            <motion.div style={{ height }} className="absolute left-0 top-1.5 w-px bg-gold" />
            {JOURNEY.map((s, i) => (
              <Stage key={s.no} stage={s} index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
